/**
 * Viveka Brand Logos
  *
   * Inline SVG data-URL lockup logos from the official Viveka Logo Kit.
    * See: https://viveka-inc.github.io/viveka-website/logo-swipes.html
     *
      * Usage rules:
       * V-Corp → Enterprise Lockup (unless company uploaded their own logo)
        * V-Coach → Coach Lockup
         * V-Client (Marketplace) → Marketplace Lockup
          */

function svgToDataUrl(svg) {
  return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svg);
}

  // Enterprise Lockup (master - dark text, blue gradient)
  const ENTERPRISE_LOCKUP_SVG = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 180 48" width="180" height="48"><defs><radialGradient id="eg2" cx="78%" cy="22%" r="65%"><stop offset="0%" stop-color="#60A5FA"/><stop offset="50%" stop-color="#3B82F6"/><stop offset="100%" stop-color="#1E3A8A"/></radialGradient></defs><svg x="4" y="4" width="40" height="40" viewBox="0 0 120 120"><circle cx="60" cy="60" r="56" fill="url(#eg2)"/><path d="M26,26 L43,30 L58,78 L77,30 L96,24 L74,99 L48,99 Z" fill="white"/></svg><text x="56" y="32" font-family="Plus Jakarta Sans,sans-serif" font-weight="800" font-size="22.4" letter-spacing="-0.3" fill="#1E293B">Viveka</text><circle cx="142" cy="30" r="2.4" fill="#FBBF24"/></svg>`;

  // Coach Lockup (master - dark text, purple gradient)
  const COACH_LOCKUP_SVG = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 180 48" width="180" height="48"><defs><radialGradient id="cg2" cx="78%" cy="22%" r="65%"><stop offset="0%" stop-color="#E879F9"/><stop offset="50%" stop-color="#A855F7"/><stop offset="100%" stop-color="#581C87"/></radialGradient></defs><svg x="4" y="4" width="40" height="40" viewBox="0 0 120 120"><circle cx="60" cy="60" r="56" fill="url(#cg2)"/><path d="M26,26 L43,30 L58,78 L77,30 L96,24 L74,99 L48,99 Z" fill="white"/></svg><text x="56" y="32" font-family="Plus Jakarta Sans,sans-serif" font-weight="800" font-size="22.4" letter-spacing="-0.3" fill="#ffffff">Viveka</text><circle cx="142" cy="30" r="2.4" fill="#FBBF24"/></svg>`;

  // Mo (master - dark text, teal gradient)
  const MARKETPLACE_LOCKUP_SVG = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 180 48" width="180" height="48"><defs><radialGradient id="mg2" cx="78%" cy="22%" r="65%"><stop offset="0%" stop-color="#5EEAD4"/><stop offset="50%" stop-color="#14B8A6"/><stop offset="100%" stop-color="#064E3B"/></radialGradient></defs><svg x="4" y="4" width="40" height="40" viewBox="0 0 120 120"><circle cx="60" cy="60" r="56" fill="url(#mg2)"/><path d="M26,26 L43,30 L58,78 L77,30 L96,24 L74,99 L48,99 Z" fill="white"/></svg><text x="56" y="32" font-family="Plus Jakarta Sans,sans-serif" font-weight="800" font-size="22.4" letter-spacing="-0.3" fill="#ffffff">Viveka</text><circle cx="142" cy="30" r="2.4" fill="#FBBF24"/></svg>`;

  // Same lockup as MARKETPLACE_LOCKUP_SVG, but with dark "Viveka" text
  // instead of white — for placement on a plain white/light background
  // (e.g. CheckoutPage's topbar), where white text is invisible.
  const MARKETPLACE_LOCKUP_DARK_TEXT_SVG = MARKETPLACE_LOCKUP_SVG.replace(
    'fill="#ffffff">Viveka</text>',
    'fill="#1E293B">Viveka</text>'
  );

  // Export as data-URLs ready to use in <img src="...">
  export const enterpriseLockupLogo = svgToDataUrl(ENTERPRISE_LOCKUP_SVG);
  export const coachLockupLogo = svgToDataUrl(COACH_LOCKUP_SVG);
  export const marketplaceLockupLogo = svgToDataUrl(MARKETPLACE_LOCKUP_SVG);
  export const marketplaceLockupLogoDarkText = svgToDataUrl(MARKETPLACE_LOCKUP_DARK_TEXT_SVG);

  /**
   * Determine which logo to show based on the current route.
    *
     * V-Coach (/v-coach or /coach routes) -> Coach lockup
      * V-Client (/employee routes) -> Marketplace lockup
       * Default (V-Corp / HR) -> Enterprise lockup
        */
  export function getLogoForRoute(pathname) {
    // Client-facing routes always get the marketplace (green) logo
    if (
      pathname.startsWith('/v-coach/client') ||
      pathname.startsWith('/saas-chats/client') ||
      pathname.startsWith('/inbox/orders')
    ) {
          return marketplaceLockupLogo;
    }
    // Coach-facing routes get the coach (purple) logo
    if (pathname.startsWith('/v-coach') || pathname.startsWith('/coach')) {
          return coachLockupLogo;
    }
    // Employee routes get the marketplace logo
    if (pathname.startsWith('/employee')) {
          return marketplaceLockupLogo;
    }
    // Default to marketplace logo (this is the marketplace app)
    return marketplaceLockupLogo;
  }
